module.exports = __webpack_public_path__ + "img/organization-info.86377bdc.png";